var _path, _line;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnBtnSmallEdit = function SvgIcnBtnSmallEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5967 15.4667L3.60541 12.7596L9.79034 6.61438L12.5231 9.29608L6.3038 15.4755L3.5967 15.4667ZM13.3744 8.45022L14.6851 7.14795C14.9495 6.8852 14.9509 6.45781 14.6881 6.19336L12.9413 4.43521C12.6785 4.17076 12.2511 4.16938 11.9867 4.43214L10.6417 5.76852L13.3744 8.45022ZM6.98064 16.4946C6.86305 16.6114 6.70387 16.6768 6.53811 16.6762L3.01784 16.6649C2.67266 16.6638 2.39374 16.3831 2.39485 16.0379L2.40618 12.5176C2.40671 12.3519 2.47307 12.1931 2.59066 12.0763L11.1409 3.58088C11.8755 2.85101 13.0626 2.85483 13.7925 3.58942L15.5394 5.34757C16.2693 6.08215 16.2654 7.26933 15.5309 7.99921L6.98064 16.4946Z",
    fill: "currentcolor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.59072,
    y1: 16.0992,
    x2: 17.7334,
    y2: 16.0992,
    stroke: "currentcolor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnBtnSmallEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_btn_small_edit.2894f5e7.svg";
export { ForwardRef as ReactComponent };